import {
    ContentDataDefinitionLoader,
    createRegisterableComponentWithData,
    isPublicationCardItem,
} from '@news-mono/web-common'
import React from 'react'
import {
    LoadMore,
    LoadMoreRouteProps,
} from '../../collections-new-loadmore/LoadMore/LoadMore'
import {
    calculateExpectedCardCountFromContentData,
    CollectionRouteProps,
} from '../../collections/collections-props.routing'
import { November } from '../../collections/November/November'
import { TimestampType } from '../../content/CardTimestamp/CardTimestamp'
import { Section } from '../../__styling/settings/sections'

export interface NovemberRouteProps
    extends CollectionRouteProps,
        LoadMoreRouteProps {
    collectionSection?: Section
    timestamp?: TimestampType
    truncateListCards?: boolean
    hasBackground?: boolean
    contentIsTangential?: boolean
}

export const NovemberRegistration = createRegisterableComponentWithData(
    'november',
    ContentDataDefinitionLoader,
    (props: NovemberRouteProps, data, services) => {
        return (
            <LoadMore
                dataDefinition={data.dataDefinitionArgs}
                services={services}
                loadMoreEnabled={props.loadMoreEnabled === true}
                data={data}
                render={(loadMoreData) => {
                    return (
                        <November
                            items={
                                loadMoreData.loaded
                                    ? {
                                          loaded: true,
                                          result: loadMoreData.result.publications.filter(
                                              isPublicationCardItem,
                                          ),
                                      }
                                    : { loaded: false }
                            }
                            expectedCards={calculateExpectedCardCountFromContentData(
                                data.dataDefinitionArgs,
                            )}
                            sectionHeader={props.sectionHeader}
                            section={props.collectionSection}
                            timestamp={props.timestamp}
                            onEvent={services.onEvent}
                            verticalSpacing={props.verticalSpacing}
                            truncateListCards={props.truncateListCards}
                            hasBackground={props.hasBackground}
                            contentIsTangential={props.contentIsTangential}
                        />
                    )
                }}
            />
        )
    },
)
